import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import "./images.css"

const array = [
    { title: "HeroHomepage", jsx: <StaticImage src="./HeroHomepageImage.jpeg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "MapMarkerImage", jsx: <StaticImage src="./MapMarkerImage.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "CompanyEmployee", jsx: <StaticImage src="./CompanyEmployeeImage.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "footerBackground", jsx: <StaticImage src="./footerBackground.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "HeroSolutions", jsx: <StaticImage src="./HeroSolutions.jpeg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "HeatPumpIconLImage", jsx: <StaticImage src="./HeatPumpIconLImage.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "HeatPumpIconSImage", jsx: <StaticImage src="./HeatPumpIconSImage.png" alt="test" imgStyle={{objectFit: "contain"}}/> },

    { title: "EdmundstonPresentation", jsx: <StaticImage src="./EdmundstonPresentation.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "GrandFallsPresentation", jsx: <StaticImage src="./GrandFallsPresentation.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "FrederictonPresentation", jsx: <StaticImage src="./FrederictonPresentation2.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "MonctonPresentation", jsx: <StaticImage src="./MonctonPresentation.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "StJohnPresentation", jsx: <StaticImage src="./StJohnPresentation.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "MiramichiPresentation", jsx: <StaticImage src="./MiramichiPresentation.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "TracadiePresentation", jsx: <StaticImage src="./ShippaganPresentation.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "BathurstPresentation", jsx: <StaticImage src="./BathurstPresentation3.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "CampbelltonPresentation", jsx: <StaticImage src="./CampbelltonPresentation.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "MainPagePresentation", jsx: <StaticImage src="./GirlHeatPumpImage.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },
    
    { title: "AndmarTeamPresentation", jsx: <StaticImage src="./AndmarTeam.jpg" alt="test" imgStyle={{objectFit: "contain"}}/> },


    { title: "enhancedEnergySavingEN", jsx: <StaticImage src="./enhancedEnergySavingEN.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "enhancedEnergySavingFR", jsx: <StaticImage src="./enhancedEnergySavingFR.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "totalHomeEnergySavingEN", jsx: <StaticImage src="./totalHomeEnergySavingEN.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "totalHomeEnergySavingFR", jsx: <StaticImage src="./totalHomeEnergySavingFR.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "greenerHomeLoanEN", jsx: <StaticImage src="./greenerHomeLoanEN.png" alt="test" imgStyle={{objectFit: "contain"}}/> },
    { title: "greenerHomeLoanFR", jsx: <StaticImage src="./greenerHomeLoanFR.png" alt="test" imgStyle={{objectFit: "contain"}}/> },

];



export default function Image(props: any) {
    return (
        <div className={`thisStaticImage ${props.className}`}>
            {array.map((x) => x.title === props.src && <div key="x.title">{x.jsx}</div>)}
        </div>
    )
};
export function BackgroundImage(props: any) {
    return (
        <div className={`thisStaticBackGroundImage ${props.className}`}>
            {array.map((x) => x.title === props.src && <div key="x.title">{x.jsx}</div>)}
        </div>
    )
};

